import { isMobile } from 'react-device-detect';

import { Box } from 'shared/ui/Box';

import styled from '@emotion/styled';

export const RootStyled = styled(Box)({
  alignItems: 'stretch',
  height: '100svh',
  overflowX: 'hidden',
  display: 'flex',
  width: '100vw',
  '::-webkit-scrollbar': {
    width: isMobile ? '0px' : '10px',
  },
});

export const ContentStyled = styled(Box)({
  width: '100%',
  height: 'fit-content',
});
